import React, {PureComponent} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import Registry from "../../../registry/index";
import NotEnoughTokensPopup from "../NotEnoughTokensPopup";

import "./styles.scss";

class DonatePanel extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            donateInfo: null,
            quantityTokens: 0,
        }
    }
    
    componentDidMount() {
        const siteInterface = Registry.get("siteInterface");
        siteInterface.getDonateInfo()
            .then(data =>
                this.setState({donateInfo: data.data})
            )
            .catch(() =>
                this.setState({donateInfo: null})
            );
    }
    
    setQuantity = value => {
        this.setState({quantityTokens: value});
    }
    
    giveToken = amount => {
        const {currentUser, user, onClose, sendingTokens, currentRoom, pm, visibleChatrooms} = this.props;

        let timeout;
        const siteInterface = Registry.get("siteInterface");
        const serverId = __login_data.server_id;

        if (Number(currentUser.wallet_amount) >= amount) {
            if (pm) {
                siteInterface.giveToken(user.uid, amount, visibleChatrooms.roomid, serverId, pm);
                onClose();
            } else {
                sendingTokens(amount);
    
                timeout = setTimeout(() => {
                    siteInterface.giveToken(user.uid, amount, visibleChatrooms.roomid, serverId);
                    sendingTokens(0);
                }, 5000);
                
                onClose(timeout);
            }
        } else {
            NotEnoughTokensPopup.open();
        }
    }
    
    
    render() {
        const lang = Registry.get("locale");
        const {donateInfo, quantityTokens} = this.state;
        const {onClose, pm} = this.props;
        if (!donateInfo) return null;
    
        const date = new Date(parseInt(donateInfo.timestamp) * 1000);
        const dateFormatted = date.format('dd/mm/yyyy');
        
        return (
            <div className="donate-panel">
                <div className="header">
                    <div className={pm ? "icon-info pm" : "icon-info"} />
                    <div className="title">{pm ? lang.pm_tokens : lang.tokens}</div>
                    <div className="icon-close" onClick={onClose} />
                    {pm ? (
                            <div className="info">
                                <div className="info-body">{lang.donate_info_pm}</div>
                            </div>
                        )
                    :
                        (
                            <div className="info">
                                <div className="info-title" dangerouslySetInnerHTML={{__html:lang.donate_info_title}}/>
                                <div className="info-body" dangerouslySetInnerHTML={{__html:lang.donate_info_body(donateInfo.sender, donateInfo.receiver, donateInfo.amount) + dateFormatted}}/>
                            </div>
                        )}
                </div>
                <div className="body">
                    <button className="token-button" onClick={() => this.giveToken(25)}>
                        <span className="count">+25 </span>
                    </button>
                    <button className="token-button" onClick={() => this.giveToken(10)}>
                        <span className="count">+10 </span>
                    </button>
                    <button className="token-button" onClick={() => this.giveToken(5)}>
                        <span className="count">+5 </span>
                    </button>
                    <input
                        type="number"
                        placeholder="50"
                        onChange={e => this.setQuantity(e.target.value)}
                        className={quantityTokens ? "input active" : "input"}
                    />
                    <div
                        onClick={() => this.giveToken(quantityTokens)}
                        className={quantityTokens ? "send active" : "send"}
                    >
                        {lang.send}
                    </div>
                </div>
            </div>
        )
        
    }
}

DonatePanel.defaultProps = {
    pm: false,
}

DonatePanel.propTypes = {
    pm: PropTypes.bool,
    user: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
    currentRoom: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
    currentUser: state.currentUser,
    currentRoom: state.currentRoom,
    visibleChatrooms: state.visibleChatrooms
})

export default connect(mapStateToProps)(DonatePanel);


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/DonatePanel/index.js